import React from 'react';
import { useIntl } from 'react-intl';
import { useRouter } from 'next/router';
import { DirectoryPage, DirectoryLayout } from '../components/DirectoryPage';
import DirectoryList from '../components/DirectoryPage/List';
import withApollo from '../lib/apollo';
import profilesConnectionQuery
from '../lib/queries/products/profilesConnectionQuery.graphql';
import messages from '../lib/messages.json';
import redirectRouteToDomain from '../lib/redirectRouteToDomain';
import {
  directoryCardImageConfigurations,
  directoryCardLogoConfigurations,
} from '../lib/imageConfigurations';
import headerImageUrls from '../lib/fashionWeekHeaderImageUrls';

export const FederationsDirectoryPage = () => {
  const intl = useIntl();
  const {
    query: {
      country,
      section,
      search,
    },
  } = useRouter();

  const FEDERATIONSLIMIT = 20;

  return (
    <DirectoryPage
      title={intl.formatMessage(messages['federations-directory.title'])}
      route="federations-directory"
      pageType="federations"
      ComponentWithQuery={DirectoryList}
      variables={{
        type: 'FEDERATION',
        first: FEDERATIONSLIMIT,
        search,
        premium: section !== 'all' || null,
        country: country || null,
        imageConfigurations: directoryCardImageConfigurations,
        logoConfigurations: directoryCardLogoConfigurations,
      }}
      query={profilesConnectionQuery}
    />
  );
};

FederationsDirectoryPage.getLayout = (page) => (
  <DirectoryLayout
    imageUrls={headerImageUrls}
    alt="FashionUnited Federations Directory"
  >
    {page}
  </DirectoryLayout>
);

FederationsDirectoryPage.getInitialProps = redirectRouteToDomain(
  'federations-directory',
);

export default withApollo(FederationsDirectoryPage);
